import type { RequestAction } from '@transcend-io/privacy-types';
import React from 'react';
import { useTheme } from 'styled-components';

import { DSRIcon } from './DSRIcon';
import { Icon } from './wrappers';

/**
 * Props
 */
export interface DsrActionIconProps {
  /** Type of the DSR action (e.g. "erasure") */
  type: RequestAction;
  /** URL for the icon to show for this item, otherwise uses the value to determine one */
  icon?: string;
  /** Is this item currently the selected item? */
  selected?: boolean;
}

/**
 * Displays a DSR Action icon
 */
export const DsrActionIcon: React.FC<DsrActionIconProps> = ({
  icon,
  type,
  selected,
  ...rest
}) => {
  const theme = useTheme();
  if (icon) {
    return <Icon src={icon} alt="" role="presentation" />;
  }
  return (
    <DSRIcon
      primaryColor={theme.colors.primary}
      selectedColor={theme.colors.white}
      selected={selected}
      type={type}
      role="presentation"
      {...rest}
    />
  );
};
